module.exports = __webpack_public_path__ + "static/star_spawn_larva_mage-04c2acd10923019590d17e028cc9c2ba.png";